import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import styles from './USPGrid.module.css';

// Named USPGrid because USP is the only application at the moment of creation of this component. Should be renamed to more generic name once we find other applications than the USP
const USPGrid: React.VFC<{
  className?: string;
  items: Array<{ Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>; text: string }>;
}> = ({ className, items }): JSX.Element => {
  return (
    <ul className={clsx(className, styles.list)}>
      {items.map(({ Icon, text }) => (
        <li key={text} className={styles.item}>
          <Icon width={48} height={48} />
          <p className={textSm}>{text}</p>
        </li>
      ))}
    </ul>
  );
};

export { USPGrid };
